import { ConditionalPartial } from '../../../../utils';
import { CreateDocumentApprovalRequestDto } from './create-document-approval.request.dto';

/**
 * DTO for updating document approval
 * All fields are optional for partial updates
 */
export class UpdateDocumentApprovalRequestDto extends ConditionalPartial(CreateDocumentApprovalRequestDto) {}
